













































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { UserType } from "@/types";
import Packs from "@/app/engine/packs/Packs";
import { COLORS } from "@/app/constants";
import GalleryList from "@/components/game/GalleryList.vue";
import EmojiPicker from "@/components/EmojiPicker.vue";
import Engine from "../app/engine/Engine";

type RoleId = "p1" | "p2" | "p3" | "p4" | "p5";

@Component({ components: { EmojiPicker, GalleryList } })
export default class Test extends Vue {
  @Prop({ required: false, default: null }) user!: UserType | null;

  colors = COLORS;
  emojis = "";
  roles: { [K in RoleId]: [number, number] } = {
    p1: [0, 0],
    p2: [0, 0],
    p3: [0, 0],
    p4: [0, 0],
    p5: [0, 0],
  };
  topics: string[] = [];
  outlinedColors: { [k: string]: boolean } = {};

  generateRoles() {
    const roleIds: RoleId[] = ["p1", "p2", "p3", "p4", "p5"];
    const roles = Engine.generateRoles(roleIds);
    roleIds.forEach((id) => {
      const index = roles[id] === "imposter" ? 1 : 0;
      this.$set(this.roles[id], index, this.roles[id][index] + 1);
    });
  }
  generateTopics() {
    this.topics.splice(0, this.topics.length);
    const topics = new Packs([]).pluck(3);
    topics.forEach((topic) => this.topics.push(topic));
  }
  toggleColor(color: string) {
    this.$set(this.outlinedColors, color, !this.outlinedColors[color]);
  }

  mounted() {
    this.generateRoles();
    this.generateTopics();
  }
}
